import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import type { Movie } from "@/types/movies";
import { deriveCountries, deriveGenres, deriveSubtitleLabel, deriveYear, findDirectorName, formatDuration, mapBackgroundImages, mapCast } from "../_shared/contentMeta";
export function useMovieDerived(movieData) {
  const $ = _c(33);
  let t0;
  if ($[0] !== movieData) {
    t0 = movieData ?? {} as Movie;
    $[0] = movieData;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const m = t0;
  let t1;
  if ($[2] !== m.release_date) {
    t1 = deriveYear(m.release_date);
    $[2] = m.release_date;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const year = t1;
  let t2;
  if ($[4] !== m.tags) {
    t2 = deriveCountries(m.tags);
    $[4] = m.tags;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const countries = t2;
  let t3;
  if ($[6] !== m.tags) {
    t3 = deriveGenres(m.tags);
    $[6] = m.tags;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const genres = t3;
  const t4 = Boolean(m.subtitles?.length);
  const t5 = Boolean(m.dubs?.length);
  let t6;
  if ($[8] !== t4 || $[9] !== t5) {
    t6 = deriveSubtitleLabel(t4, t5);
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const subtitles = t6;
  let t7;
  if ($[11] !== m.medias) {
    t7 = m.medias ?? [];
    $[11] = m.medias;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t7) {
    t8 = mapBackgroundImages(t7);
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const images = t8;
  let t9;
  if ($[15] !== m.persons) {
    t9 = m.persons ?? [];
    $[15] = m.persons;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  const persons = t9;
  let t10;
  if ($[17] !== persons) {
    t10 = mapCast(persons);
    $[17] = persons;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  const cast = t10;
  let t11;
  if ($[19] !== persons) {
    t11 = findDirectorName(persons);
    $[19] = persons;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  const directorName = t11;
  const t12 = m.duration ?? "";
  let t13;
  if ($[21] !== t12) {
    t13 = formatDuration(t12);
    $[21] = t12;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  const durationLabel = t13;
  let t14;
  if ($[23] !== cast || $[24] !== countries || $[25] !== directorName || $[26] !== durationLabel || $[27] !== genres || $[28] !== images || $[29] !== persons || $[30] !== subtitles || $[31] !== year) {
    t14 = {
      year,
      countries,
      genres,
      subtitles,
      images,
      persons,
      cast,
      directorName,
      durationLabel
    };
    $[23] = cast;
    $[24] = countries;
    $[25] = directorName;
    $[26] = durationLabel;
    $[27] = genres;
    $[28] = images;
    $[29] = persons;
    $[30] = subtitles;
    $[31] = year;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  return t14;
}